webpackJsonp([147560939084620],{

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatting = __webpack_require__(49);
	
	var _markdown = __webpack_require__(22);
	
	var _metadata = __webpack_require__(208);
	
	var _siteMetadata = __webpack_require__(72);
	
	var _Metadata = __webpack_require__(73);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Page = __webpack_require__(210);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SearchResults = __webpack_require__(212);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryPage = function CategoryPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	
	  var metadata = (0, _siteMetadata.categoryPageMetadata)(data);
	  var category = pathContext.category;
	
	
	  var articles = (0, _markdown.markdownItemNodes)(data);
	
	  return _react2.default.createElement(
	    _Page2.default,
	    { title: (0, _formatting.categoryTitle)(category) },
	    _react2.default.createElement(_Metadata2.default, (0, _metadata.addTitleToMetadata)(metadata, category)),
	    _react2.default.createElement(_SearchResults2.default, {
	      articles: articles,
	      title: [(0, _formatting.pluraliseWithNumber)((0, _siteMetadata.articlesResourceTitle)(data), articles.length) + ' filed in', category]
	    })
	  );
	};
	
	CategoryPage.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	};
	
	exports.default = CategoryPage;
	module.exports = exports['default'];

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CategoryPage = __webpack_require__(501);
	
	var _CategoryPage2 = _interopRequireDefault(_CategoryPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _CategoryPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.addTitleToMetadata = undefined;
	
	var _ramda = __webpack_require__(1);
	
	// eslint-disable-next-line import/prefer-default-export
	var addTitleToMetadata = exports.addTitleToMetadata = function addTitleToMetadata(metadata, s) {
	  return (0, _ramda.over)((0, _ramda.lensProp)('title'), (0, _ramda.concat)(s), metadata);
	};

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ArticleFooterMeta = __webpack_require__(161);
	
	var _ArticleFooterMeta2 = _interopRequireDefault(_ArticleFooterMeta);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ArticleFooterMeta2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderListItems = __webpack_require__(98);
	
	var _renderListItems2 = _interopRequireDefault(_renderListItems);
	
	var _VList = __webpack_require__(115);
	
	var _VList2 = _interopRequireDefault(_VList);
	
	var _ArticlesListItem = __webpack_require__(101);
	
	var _ArticlesListItem2 = _interopRequireDefault(_ArticlesListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticlesList = function ArticlesList(_ref) {
	  var articles = _ref.articles;
	  return _react2.default.createElement(
	    _VList2.default,
	    null,
	    (0, _renderListItems2.default)(_ArticlesListItem2.default, 'article', articles)
	  );
	};
	
	ArticlesList.propTypes = {
	  articles: _propTypes2.default.array.isRequired
	};
	
	exports.default = ArticlesList;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(138);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _markdown = __webpack_require__(22);
	
	var _VLayout = __webpack_require__(19);
	
	var _VLayout2 = _interopRequireDefault(_VLayout);
	
	var _TextLink = __webpack_require__(33);
	
	var _TextLink2 = _interopRequireDefault(_TextLink);
	
	var _TitleSecondary = __webpack_require__(119);
	
	var _TitleSecondary2 = _interopRequireDefault(_TitleSecondary);
	
	var _spaceChildrenH = __webpack_require__(55);
	
	var _spaceChildrenH2 = _interopRequireDefault(_spaceChildrenH);
	
	var _spaceChildrenV = __webpack_require__(34);
	
	var _spaceChildrenV2 = _interopRequireDefault(_spaceChildrenV);
	
	var _ArticleFooterMeta = __webpack_require__(99);
	
	var _ArticleFooterMeta2 = _interopRequireDefault(_ArticleFooterMeta);
	
	var _ArticleHeadMeta = __webpack_require__(162);
	
	var _ArticleHeadMeta2 = _interopRequireDefault(_ArticleHeadMeta);
	
	var _PolyImage = __webpack_require__(109);
	
	var _PolyImage2 = _interopRequireDefault(_PolyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _styledComponents2.default.div.withConfig({
	  displayName: 'ArticlesListItem__Layout'
	})(['display:flex;', ';', ';', ';> *:first-child{', ';}'], (0, _cssapi.api)({
	  flexDirection: ['column', 'column', 'row']
	}), (0, _spaceChildrenH2.default)([0, 0, '1.5ru']), (0, _spaceChildrenV2.default)(['1ru', '1ru', 0]), (0, _cssapi.api)({
	  flex: ['0 0 auto', '0 0 auto', '0 0 33.3%']
	}));
	
	var TextLayout = (0, _styledComponents2.default)(_VLayout2.default).withConfig({
	  displayName: 'ArticlesListItem__TextLayout'
	})(['flex:0 0 auto;']);
	
	var ArticlesListItem = function ArticlesListItem(_ref) {
	  var article = _ref.article;
	
	  var title = (0, _markdown.fieldsTitle)(article);
	  var color = (0, _markdown.fieldsColor)(article);
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: (0, _markdown.fieldsSlug)(article), title: title },
	      _react2.default.createElement(_PolyImage2.default, { imageSizes: (0, _markdown.frontmatterImageSizes)(article), color: color })
	    ),
	    _react2.default.createElement(
	      TextLayout,
	      { spacing: 'small' },
	      _react2.default.createElement(
	        _TextLink2.default,
	        { to: (0, _markdown.fieldsSlug)(article), title: title, underlineType: 'left' },
	        _react2.default.createElement(
	          _TitleSecondary2.default,
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(_ArticleHeadMeta2.default, { article: article }),
	      _react2.default.createElement(
	        'p',
	        null,
	        article.excerpt
	      ),
	      _react2.default.createElement(_ArticleFooterMeta2.default, { article: article })
	    )
	  );
	};
	
	ArticlesListItem.propTypes = {
	  article: _propTypes2.default.object.isRequired
	};
	
	exports.default = ArticlesListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(1);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArticleList = __webpack_require__(100);
	
	var _ArticleList2 = _interopRequireDefault(_ArticleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Articles = function Articles(_ref) {
	  var articles = _ref.articles;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    (0, _ramda.isEmpty)(articles) ? _react2.default.createElement(
	      'div',
	      null,
	      'No Articles Yet'
	    ) : _react2.default.createElement(_ArticleList2.default, { articles: articles })
	  );
	};
	
	Articles.propTypes = {
	  articles: _propTypes2.default.array.isRequired
	};
	
	exports.default = Articles;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PolyImage = __webpack_require__(163);
	
	var _PolyImage2 = _interopRequireDefault(_PolyImage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _PolyImage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Articles = __webpack_require__(102);
	
	var _Articles2 = _interopRequireDefault(_Articles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meta = _styledComponents2.default.header.withConfig({
	  displayName: 'SearchResults__Meta'
	})(['text-align:center;']);
	
	var SearchResults = function SearchResults(_ref) {
	  var articles = _ref.articles,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        Meta,
	        null,
	        title[0],
	        ' ',
	        _react2.default.createElement(
	          'i',
	          null,
	          title[1]
	        )
	      ),
	      _react2.default.createElement(_Articles2.default, { articles: articles })
	    )
	  );
	};
	
	SearchResults.propTypes = {
	  articles: _propTypes2.default.array,
	  title: _propTypes2.default.array.isRequired
	};
	
	SearchResults.defaultProps = {
	  articles: []
	};
	
	exports.default = SearchResults;
	module.exports = exports['default'];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SearchResults = __webpack_require__(211);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _SearchResults2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _uiList = __webpack_require__(164);
	
	var _uiList2 = _interopRequireDefault(_uiList);
	
	var _VLayout = __webpack_require__(19);
	
	var _VLayout2 = _interopRequireDefault(_VLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VList = (0, _styledComponents2.default)(_VLayout2.default.withComponent('ul')).withConfig({
	  displayName: 'VList'
	})(['', ';'], _uiList2.default);
	
	exports.default = VList;
	module.exports = exports['default'];

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _graphql = __webpack_require__(58);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _CategoryPage = __webpack_require__(502);
	
	var _CategoryPage2 = _interopRequireDefault(_CategoryPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CategoryPage2.default;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-components-templates-category-js-604bebc41330ca693d83.js